<div
  [ngClass]="{
    active: dateSubmitted && reviewStatus,
    'review-status-box': true,
  }"
>
  <h2>REVIEW STATUS</h2>
  <div class="review-status">
    @if (submissionDue) {
      <div class="review-status-type">
        <div>
          <p>Submission Due:</p>
          <p class="thick">{{ submissionDue }}</p>
        </div>
      </div>
    }
    @if (dateSubmitted && reviewStatus) {
      <div class="review-status-type">
        <div>
          <p>Date Submitted:</p>
          <p class="thick">{{ dateSubmitted + '+0000' | date: 'MM/dd/yy' }}</p>
        </div>
        <div class="review-status-row">
          <p>Review Status:</p>
          <p class="thick">{{ reviewStatus }}</p>
          <span cdkOverlayOrigin #trigger="cdkOverlayOrigin">
            @if (systemForced) {
              <mat-icon
                aria-label="info icon"
                (mouseenter)="isOpen = true"
                (mouseleave)="isOpen = false"
                >info</mat-icon
              >
            }
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayOpen]="isOpen"
            >
              <mat-card class="popover-content">
                <mat-card-content>
                  This submission status was automatically updated by the system
                  submission process.
                </mat-card-content>
              </mat-card>
            </ng-template>
          </span>
        </div>
      </div>
    }
    @if (lastReviewed) {
      <div class="review-status-type">
        <div>
          <p>Last reviewed:</p>
          <p class="thick">{{ lastReviewed }}</p>
        </div>
      </div>
    }
  </div>
</div>
